import { careplanConstants as constants } from '../_constants/careplan.constants'
import { carePlanService as service } from '../_services/careplan.service';

export function addFavoriteAndSet(favorite) {
  return { type: constants.FCP_ADD_SET, favorite }
}

export function setFavorite(favorite) {
  return { type: constants.FCP_SET_FAVORITE, favorite }
}

export function setCurrent(carePlan) {
  return { type: constants.FCP_SET_CURRENT, carePlan }
}

export function setFiles(files) {
  return { type: constants.FCP_SET_FILES, files }
}

export function setAttachments(attachments) {
  return { type: constants.FCP_SET_ATTACHMENTS, attachments }
}

export function setPhysicalExam(text) {
  return { type: constants.FCP_SET_PHYSICAL_EXAM, text }
}

export function setImaging(text) {
  return { type: constants.FCP_SET_IMAGING, text }
}

export function setDiagnosis(text) {
  return { type: constants.FCP_SET_DIAGNOSIS, text }
}

export function setCarePlan(text) {
  return { type: constants.FCP_SET_CARE_PLAN, text }
}

export function retrieveFavorites() {
  return dispatch => {
    service.retrieveFavorites()
      .then((favorites) => {
        dispatch(success(favorites.data));
      })
      .catch(() => {
        dispatch(failure());
      });
  }

  function success(favorites) {
    return { type: constants.FCP_RETRIEVE_SUCCESS, favorites }
  }
  function failure() {
    return { type: constants.FCP_RETRIEVE_FAILURE }
  }
}

export function clearCurrent() {
  return { type: constants.FCP_CLEAR_CURRENT }
}